import { render, staticRenderFns } from "./ObjectPopup.vue?vue&type=template&id=6c826bec&scoped=true&"
import script from "./ObjectPopup.vue?vue&type=script&lang=js&"
export * from "./ObjectPopup.vue?vue&type=script&lang=js&"
import style0 from "./ObjectPopup.vue?vue&type=style&index=0&id=6c826bec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c826bec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VIcon,VImg,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VMenu})
